import React from 'react';
import { Form } from '../../../ui/universe';
import { TagInput, Tooltip } from 'tdesign-react';
import { showErrorMessage } from '../../../../utils/message.jsx';

/**
 * StringTag 参数渲染器
 * value 为字符串数组（如枚举值集合），直接透传给接口，不做 KeyName/KeyType 包装
 * 支持 maxCount（元素个数上限）与 itemMaxLength（单个元素长度上限）
 */
function StringTagRenderer({ params, value, disabled, onChange }) {
  const tags = Array.isArray(value) ? value : [];
  const maxCount = params.maxCount;
  const itemMaxLength = params.itemMaxLength;

  const handleChange = (val) => {
    const list = Array.isArray(val) ? val : [];
    if (maxCount && list.length > maxCount) {
      showErrorMessage(`最多支持 ${maxCount} 个`);
      return;
    }
    const overLength = itemMaxLength
      ? list.find((item) => String(item).length > itemMaxLength)
      : null;
    if (overLength) {
      showErrorMessage(`单个元素长度不能超过 ${itemMaxLength} 字符`);
      return;
    }
    onChange && onChange(list);
  };

  return (
    <Form.Item
      className={`${params.LabelAlign ? 'column' : 'row'}`}
      label={
        <>
          <span>{params.label}</span>
          {params.des && (
            <Tooltip content={params.des} theme="light">
              <span className="ocrDemo-icon-question"></span>
            </Tooltip>
          )}
        </>
      }
    >
      <TagInput
        value={tags}
        placeholder={params.placeholder || '输入后回车添加'}
        excessTagsDisplayType="break-line"
        size="medium"
        disabled={disabled}
        onChange={handleChange}
        onClear={() => onChange && onChange([])}
        clearable
      />
    </Form.Item>
  );
}

export default StringTagRenderer;
